import React from 'react';
import {connect} from 'react-redux';
import Header from '../../../header';
import Menu from '../../../menu';
import GuidedToursListPopup from '../../../popup/components/guided-tours-list-popup';
import SupportDetailsPopup from '../../../popup/components/support-details-popup';
import Content from '../../../content';
import {withRouter} from 'react-router-dom';
import WaitingPanelPage from "../../../waiting-panel-page";
import i18n from '../../../../../i18n';
import {I18nextProvider} from 'react-i18next';

class NotReadyTemplate extends React.Component {
	render() {
		return (
			<I18nextProvider i18n={i18n}>
				<div className="app not-ready">
					<Header msgBar={false} />
					<Menu/>
					<GuidedToursListPopup/>
					<SupportDetailsPopup/>
					<Content>
                        <WaitingPanelPage/>
					</Content>
				</div>
			</I18nextProvider>
		)
	}
}

const mapStateToProps = state => ({
	language : state.languageReducer.language
});

export default withRouter(connect(mapStateToProps)(NotReadyTemplate));
